import type { GridFilterModel } from "@mui/x-data-grid";

/**
 * Whether the MUI filter model actually constrains rows.
 * While clearing, the grid often keeps `items.length > 0` with an empty string
 * value — treating that as "active" forces a second clear before unfiltered fetch runs.
 */
export function muiFilterModelHasActiveItems(model: GridFilterModel): boolean {
  return model.items.some((item) => {
    if (item.operator === "isEmpty" || item.operator === "isNotEmpty") {
      return true;
    }
    if (item.operator === "isAnyOf") {
      return Array.isArray(item.value) && item.value.length > 0;
    }
    const v = item.value;
    return v !== undefined && v !== null && v !== "";
  });
}
